@if (isLoading()) {
<app-loader></app-loader>
}

<div class="container container-profile container-profile-company-student" [class.d-none]="isLoading()">

  <div class="content mt-4">

    <div class="row">

      <div class="col-12 col-sm-3 sidebar sidebar-left">

        <!-- profile image -->
        <div class="card">

          <div class="card-body">

            <div class="profile-image-wrapper">
              <div class="profile-image-holder circle">
                <img class="profile-image image img-fluid" [src]="entity.avatarUri ? entity.avatarUri : avatarPlaceholder">
              </div>
            </div>

          </div>

        </div>

        <div class="card mt-4">

          <div class="card-body">
            <h4 class="card-title">{{'Contact details' | translate}}</h4>

            <p>{{entity.firstName}} {{entity.lastName}}</p>
            <p>{{entity.homeAddress.city}}, {{locale.getCountryName(entity.homeAddress.country)}}</p>

          </div>
        </div>

        <!-- interest -->
        <div class="card mt-4">

          <div class="card-body">

            <h4 class="card-title">{{'Field of interest' | translate}}</h4>

            <ul class="list-group" *ngIf="entity.areaOfInterests && entity.areaOfInterests.length>0">
              <li *ngFor="let interest of entity.areaOfInterests; trackBy: trackById" class="list-group-item">
                {{interest.name | translate}}
              </li>
            </ul>

          </div>
        </div>

      </div>

      <div class="col-12 col-sm-9 main">

        <!-- general info -->
        <div class="card">

          <div class="card-body">

            <h3 class="card-title d-flex justify-content-between">

              <div class="name">
                {{entity.firstName}} {{entity.lastName}}
              </div>

              <div class="btn-toolbar">

                <a class="btn btn-secondary ml-auto mr-2" (click)="goBack()">
                  {{'Back' | translate}}
                </a>

                <button *ngIf="hasDownloadPDF()" type="button" class="btn btn-secondary ml-auto mr-2" (click)="downloadPDF()">
                  <fa-icon [icon]="faDownload"></fa-icon> {{'Download PDF' | translate}}
                </button>

                <button type="button" class="btn btn-danger ml-auto mr-0" (click)="showContactDetails()">
                  <fa-icon [icon]="faAddressCard"></fa-icon> {{'Contact' | translate}}
                </button>

              </div>

            </h3>

            <div>{{'Is currently' | translate}}: {{entity.profileType ? (ProfileTypeUtils.getName(entity.profileType) | translate) : ''}}</div>
            <div>{{'Currently looking for' | translate}}: {{entity.lookingFor ? (ProfileLookingForUtils.getName(entity.lookingFor) | translate) : ''}}</div>
            <div class="languages" *ngIf="entity.languageProficiencies?.length">
              <fa-icon [icon]="faLanguage"></fa-icon>&nbsp;
              <span *ngFor="let lang of entity.languageProficiencies; let key=index; trackBy: trackById">{{locale.getLanguageName(lang.languageCode ?? '') + (entity.languageProficiencies!.length-1 === key ? '':', ')}}</span>
            </div>

            <div *ngIf="entity.homeAddress">
              <fa-icon [icon]="faMapMarker"></fa-icon>&nbsp;
              <span *ngIf="entity.homeAddress.city">{{entity.homeAddress.city}}</span>
              <span *ngIf="entity.homeAddress.country">, {{locale.getCountryName(entity.homeAddress.country)}}</span>
            </div>

          </div>

        </div>

        <!-- announcements / oproepen -->
        <div class="card mt-4" *ngIf="oproepen()?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Announcements' | translate}}</h3>

            <hr>

            <div class="item-announcement" *ngFor="let oproep of oproepen(); trackBy: trackById">

              <h4 class="title font-weight-bold">
                <fa-icon [icon]="faBullhorn" class="text-success"></fa-icon>&nbsp;{{oproep.lookingFor ? (ProfileLookingForUtils.getName(oproep.lookingFor) | translate) : ('Announcements' | translate)}}
              </h4>

              <div class="announcement-meta text-muted mb-2">
                <span *ngIf="oproep.startDateTime">{{oproep.startDateTime | date: "dd-MM-yyyy"}} &ndash; {{isOpenEnded(oproep.endDateTime) ? ('Ongoing' | translate) : (oproep.endDateTime | date: "dd-MM-yyyy")}}</span>
                <span *ngIf="oproep.highestEducation"> &middot; {{oproep.highestEducation}}</span>
              </div>

              <p class="announcement-description mb-0" style="white-space: pre-wrap" *ngIf="oproep.personalDescription">{{oproep.personalDescription}}</p>

            </div>

          </div>

        </div>

        <!-- educations -->
        <div class="card mt-4" *ngIf="entity.educations?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Educations' | translate}}</h3>

            <hr>

            <div class="item-education mb-3" *ngFor="let education of entity.educations; trackBy: trackById">

              <h4 class="title font-weight-bold" *ngIf="education.programName">
                {{'Education' | translate}}: {{education.programName}}
              </h4>

              <div class="row">

                <div class="col-sm-6">

                  <div *ngIf="education.level">
                    {{'Education level' | translate}}: {{education.level}}
                  </div>

                  <div *ngIf="education.profile">
                    {{'Profile' | translate}}: {{education.profile}}
                  </div>

                  <div *ngIf="education.extras">
                    {{'Courses / minors / electives' | translate}}: <div style="white-space: pre-wrap" [innerHTML]="education.extras | safeHtml"></div>
                  </div>

                  <div *ngIf="education.isCurrent">
                    {{'Current education' | translate}}
                  </div>

                  <div *ngIf="education.graduated">
                    {{'Graduated' | translate}}
                  </div>

                  <div class="education-period" *ngIf="education.startDate">
                    {{'Period' | translate}}: {{education.startDate | date: "dd-MM-YYYY"}}{{education.endDate ? ' - ' + (education.endDate | date: "dd-MM-YYYY") : ''}}
                  </div>

                </div>

                <div class="col-sm-6">
                  <div class="school">
                    <div class="school-name" *ngIf="education.schoolName">
                      {{'School' | translate}}: {{education.schoolName}}
                    </div>
                    <div class="school-city" *ngIf="education.schoolCity">
                      {{'City' | translate}}: {{education.schoolCity}}
                    </div>
                    <div class="school-country" *ngIf="education.schoolCountry">
                      {{'Country' | translate}}: {{locale.getCountryName(education.schoolCountry)}}
                    </div>

                  </div>
                </div>

              </div>





            </div>

          </div>

        </div>

        <!-- work experiences -->
        <div class="card mt-4" *ngIf="entity.workExperiences?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Work experience' | translate}}</h3>

            <hr>

            <div class="item-work-experience mb-3" *ngFor="let row of entity.workExperiences; trackBy: trackById">

              <h4 class="job-title" *ngIf="row.jobTitle">
                {{'Job title' | translate}}: {{row.jobTitle}}
              </h4>

              <div class="job-description" *ngIf="row.description">
                {{'Job description' | translate}}: {{row.description}}
              </div>

              <div class="location" *ngIf="row.location">
                {{'Location' | translate}}: {{row.location}}
              </div>

              <div class="company-name" *ngIf="row.companyName">
                {{'Company' | translate}}: {{row.companyName}}
              </div>

              <div class="company-url" *ngIf="row.companyUrl">
                {{'Website' | translate}}: <a [href]="row.companyUrl" target="_blank">{{row.companyUrl}}</a>
              </div>

              <div class="workexperience-period" *ngIf="row.startDate">
                {{'Period' | translate}}: {{row.startDate | date: "dd-MM-YYYY"}}{{row.endDate ? ' - ' + (row.endDate | date: "dd-MM-YYYY") : ''}}
              </div>

            </div>

          </div>

        </div>

        <!-- foreign experiences -->
        <div class="card mt-4" *ngIf="entity.foreignExperiences?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Foreign experience' | translate}}</h3>

            <hr>

            <div class="item-foreign-experience mb-3" *ngFor="let row of entity.foreignExperiences; trackBy: trackById">

              <h4 class="job-title" *ngIf="row.title">
                {{'Experience' | translate}}: {{row.title}}
              </h4>

              <div class="job-description" *ngIf="row.description">
                {{'Description' | translate}}: {{row.description}}
              </div>

              <div class="location" *ngIf="row.country">
                {{'Country' | translate}}: {{locale.getCountryName(row.country)}}
              </div>

              <div class="company-name" *ngIf="row.companyInformation">
                {{'Company' | translate}}: {{row.companyInformation}}
              </div>

              <div class="workexperience-period" *ngIf="row.startDate">
                {{'Period' | translate}}: {{row.startDate | date: "dd-MM-YYYY"}}{{row.endDate ? ' - ' + (row.endDate | date: "dd-MM-YYYY") : ''}}
              </div>

            </div>

          </div>

        </div>

        <!-- languages -->
        <div class="card mt-4" *ngIf="entity.languageProficiencies?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Languages' | translate}}</h3>

            <hr>

            <div class="row">

              <div class="col-sm-4 item-language mb-3" *ngFor="let row of entity.languageProficiencies; trackBy: trackById">

                <h4 class="language-title" *ngIf="row.languageCode">
                  {{'Language' | translate}}: {{locale.getLanguageName(row.languageCode)}}
                </h4>

                <div class="job-description" *ngIf="row.readingProficiency">
                  {{'Reading' | translate}}: {{studentService.getLanguageProficiencyLevelName(row.readingProficiency) | translate}}
                </div>

                <div class="job-description" *ngIf="row.writingProficiency">
                  {{'Writing' | translate}}: {{studentService.getLanguageProficiencyLevelName(row.writingProficiency) | translate}}
                </div>

                <div class="job-description" *ngIf="row.speakingProficiency">
                  {{'Speech' | translate}}: {{studentService.getLanguageProficiencyLevelName(row.speakingProficiency) | translate}}
                </div>

              </div>

            </div>

          </div>

        </div>

        <!-- interests -->
        <div class="card mt-4" *ngIf="entity.interests?.length">

          <div class="card-body">

            <h3 class="card-title">{{'Hobby / interest' | translate}}</h3>

            <hr>

            <div class="item-work-experience mb-3" *ngFor="let row of entity.interests; trackBy: trackById">

              <p class="interest-description" *ngIf="row['description']">
                {{row['description']}}
              </p>

            </div>

          </div>

        </div>

        <!-- CVs -->
        <div class="card mt-4" *ngIf="entity.studentProfileCvs && entity.studentProfileCvs.length > 0">
          <div class="card-body">

            <h3 class="card-title">{{'Resume' | translate}}</h3>

            <hr>

            <table class="table table-borderless">
              <thead>
                <tr>
                  <th>
                    {{'Date' | translate}}
                  </th>
                  <th>
                    {{'File' | translate}}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of entity.studentProfileCvs; trackBy: trackById">
                  <td>
                    {{row.createdOn | date:'dd-MM-YYYY'}}
                  </td>
                  <td>
                    {{row.filename}}
                  </td>
                  <td class="text-right">
                    <div class="btn-group">

                      <a class="btn btn-secondary" [href]="row.uri" target="_blank">
                        <fa-icon [icon]="faDownload"></fa-icon> {{'Download' | translate}}
                      </a>
                    </div>

                  </td>
                </tr>
              </tbody>

              <tbody *ngIf="!entity.studentProfileCvs || entity.studentProfileCvs.length == 0">
                <tr>
                  <td colspan="2">
                    {{'No results' | translate}}
                  </td>
                </tr>
              </tbody>

            </table>

          </div>
        </div>

      </div>

    </div>

  </div>

</div>
